export enum MatchType {
  Offline = 'offline_match',
  Online = 'online_match',
}
